<div class="bpx-file-uploader bpx-uploader"
     [class.bpx-uploader--loaded]="!!selectedFile"
     dragAndDrop (fileDropped)="onFilesDropped($event)">

  <span class="material-icons bpx-uploader__icon" aria-hidden="true">cloud_upload</span>
  <p class="bpx-uploader__title" i18n>Drag and drop your file here</p>
  <p class="bpx-uploader__hint" i18n>or pick one from your computer</p>
  <form class="bpx-uploader__native" [formGroup]="fileSelectionForm">
    <input type="file" #fileSelector
           formControlName="file_selection"
           [accept]="config.mimeTypesAccepted">
  </form>
  <button matRipple
          type="button"
          class="file-upload__browse bpx-btn bpx-btn--primary"
          (click)="openFileSelector()" i18n>
    Select File
  </button>

  @if (selectedFile) {
    <div class="bpx-uploader__list">
      <div class="bpx-file-row"
           [class.bpx-file-row--done]="selectedFile.uploadResult === 'success'"
           [class.bpx-file-row--error]="!!selectedFile.uploadResult && selectedFile.uploadResult !== 'success'">
        @if (selectedFile.uploadResult === 'success') {
          <span class="material-icons bpx-file-row__glyph" aria-hidden="true">check_circle</span>
        } @else if (!!selectedFile.uploadResult) {
          <span class="material-icons bpx-file-row__glyph" aria-hidden="true">error_outline</span>
        } @else {
          <span class="material-icons bpx-file-row__glyph" aria-hidden="true">description</span>
        }

        <div class="bpx-file-row__body">
          <div class="bpx-file-row__name" [title]="selectedFile.file.name">{{ selectedFile.file.name }}</div>
          <div class="bpx-file-row__meta">
            <span>{{ formatFileSize(selectedFile.file.size) }}</span>
            @if (selectedFile.isUploadInProgress) {
              <span class="bpx-file-row__sep" aria-hidden="true">&middot;</span>
              <span i18n>Uploading&hellip;</span>
            } @else if (selectedFile.uploadResult === 'success') {
              <span class="bpx-file-row__sep" aria-hidden="true">&middot;</span>
              <span class="bpx-file-row__status--done" i18n>Uploaded</span>
            } @else if (!!selectedFile.uploadResult) {
              <span class="bpx-file-row__sep" aria-hidden="true">&middot;</span>
              <span class="bpx-file-row__status--error" role="alert">{{ selectedFile.uploadResult }}</span>
            }
          </div>
        </div>

        <div class="bpx-file-row__actions">
          <button *ngIf="selectedFile.uploadResult !== 'success'"
                  matRipple
                  type="button"
                  class="selected_file__upload bpx-btn bpx-btn--icon bpx-file-row__upload"
                  matTooltip="Upload"
                  matTooltipPosition="left"
                  aria-label="Upload File"
                  (click)="uploadFile()"
                  [disabled]="selectedFile.isUploadInProgress">
            <span aria-hidden="true" class="material-icons">file_upload</span>
          </button>
          <button matRipple
                  type="button"
                  class="selected_file__cancel bpx-btn bpx-btn--icon bpx-btn--row-remove"
                  matTooltip="Remove"
                  matTooltipPosition="left"
                  aria-label="Cancel File"
                  (click)="cancelFile()">
            <span aria-hidden="true" class="material-icons">clear</span>
          </button>
        </div>

        <mat-progress-bar *ngIf="selectedFile.isUploadInProgress"
                          class="bpx-file-row__progress"
                          mode="indeterminate"></mat-progress-bar>
      </div>

      <div class="bpx-control ref-comment">
        <span class="bpx-control__label" id="ref-comment-label" i18n>Comment</span>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field bpx-field--textarea">
          <textarea matInput
                    aria-labelledby="ref-comment-label"
                    [(ngModel)]="comment"
                    (ngModelChange)="onCommentChange()"
                    rows="2"
                    [disabled]="selectedFile.uploadResult === 'success'"></textarea>
        </mat-form-field>
        @if (commentError) {
          <span class="comment-error" role="alert" i18n>Comment is required.</span>
        }
      </div>
    </div>
  }
</div>
